import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
  Stack,
} from "@chakra-ui/core";
import { AiFillSafetyCertificate } from "react-icons/ai";
import { MdMessage } from "react-icons/md";
import {
  FaWallet,
  FaCheck,
  FaCcVisa,
  FaCcMastercard,
  FaCcPaypal,
  FaCcApplePay,
} from "react-icons/fa";

function LandingSectionThree() {
  return (
    <Box py={["48px","60px","72px","76px"]} bg="white" w="100%">
      <Flex maxW="1280px" m="auto" w="100%">
        <Box minWidth="340px" w="100%" px="16px" m="auto">
          <Box textAlign="center" m="auto" w="100%" maxW="2xl">
            <Heading
              color="primary.500"
              as="h1"
              size="xl"
              lineHeight="shorter"
              fontWeight="bolder"
              m={0}
            >
              Instant benefits
            </Heading>

            <Text opacity="0.7" m={0} color="primary.500" fontSize="lg" mt="2">
              When it comes to simplicity, you can’t beat a click.
            </Text>
          </Box>
        </Box>
      </Flex>
      <Flex
        color="primary.500"
        justifyContent="center"
        pt="20px"
        maxW="1490px"
        flexWrap="wrap"
        m="auto"
        w="100%"
        spacing={0}
      >
        <Box
          p={["10px", "10px", "10px", "40px"]}
          w={["90%", "80%", "70%", "33%"]}
          minW={["340px", "490px", "490px", "300px"]}
          textAlign="left"
        >
          <Box
            my="12px"
            color="success.transparent-600"
            size="48px"
            as={AiFillSafetyCertificate}
          />
          <Heading
            color="primary.500"
            as="h4"
            size="md"
            lineHeight="shorter"
            fontWeight="bold"
          >
            Convenient and secure.
          </Heading>

          <Text fontSize="md" mt="2">
            Who still has the time to write a check or manipulate cash or even
            set up a complicated bank transfer? Reduce frictions, save time, and
            stay safe.
          </Text>
          <List fontSize="sm" opacity="0.9" mt="12px" pl="12px" spacing={2}>
            <ListItem>
              <ListIcon icon={FaCheck} color="success.400" />
              Contact less, Customers collect or Delivery driver drop and leave.
            </ListItem>
            <ListItem>
              <ListIcon icon={FaCheck} color="success.400" />
              Secure, no cash, no cheque, no wire, no risks.
            </ListItem>
            <ListItem>
              <ListIcon icon={FaCheck} color="success.400" />
              Fast, get payment update and status in realtime.
            </ListItem>
          </List>
        </Box>
        <Box
          p={["10px", "10px", "10px", "40px"]}
          w={["90%", "80%", "70%", "33%"]}
          minW={["340px", "490px", "490px", "300px"]}
          textAlign="left"
        >
          <Box
            my="12px"
            color="success.transparent-600"
            size="48px"
            as={MdMessage}
          />
          <Heading
            color="primary.600"
            as="h4"
            size="md"
            lineHeight="shorter"
            fontWeight="bold"
          >
            Boost customer engagement.
          </Heading>

          <Text fontSize="md" mt="2">
            By requesting payment in an existing text conversation, you’ll see
            much higher response rates than with traditional methods.
          </Text>
        </Box>
        <Box
          p={["10px", "10px", "10px", "40px"]}
          w={["90%", "80%", "70%", "33%"]}
          minW={["340px", "490px", "490px", "300px"]}
          textAlign="left"
        >
          <Box
            my="12px"
            color="success.transparent-600"
            size="48px"
            as={FaWallet}
          />
          <Heading
            color="primary.500"
            as="h4"
            size="md"
            lineHeight="shorter"
            fontWeight="bold"
          >
            Localized Payment methods
          </Heading>

          <Text fontSize="md" mt="2">
            Accept all major debit and credit card payments in 130+ currencies.
            Support more than just cards using global payment methods, which you
            can activate from your Dashboard.
          </Text>
          <Stack m="12px" color="warning.300" isInline spacing={4}>
            <Box size="36px" as={FaCcVisa} />
            <Box size="36px" as={FaCcMastercard} />
            <Box size="36px" as={FaCcPaypal} />
            <Box size="36px" as={FaCcApplePay} />
          </Stack>
        </Box>
      </Flex>
    </Box>
  );
}

export default LandingSectionThree;
